import { Component } from "react"
import ClientLineItem from "../../../Domain/ClientLineItem";
import InputTypesEnum from "../../../Enums/InputTypesEnum";
import ValidityHelper from "../../../Helpers/ValidityHelper";
import ClientLineItemService from "../../../Services/ClientLineItemService";

class EditClientLineWindowDescription extends Component {
    static titleForCreate = "Add New Credit Line";
    static titleForEdit = "Edit Credit Line";
    static itemType = ClientLineItem;
    static serviceFunction = (edited) => ClientLineItemService.EditClientLineItem(edited);
    static nameOfIdField = "ClId"


    static pagesInGeneralEditWizzard = [
        {
            label: "General",
            fields: [
                { fieldName: "ClId", label: "ID", className: "col-12", type: InputTypesEnum.TextReadOnly, validityChecker: ValidityHelper.AlwaysFlawless },
                { fieldName: "ClCfid", label: "Project", className: "col-12", type: InputTypesEnum.ProjectSelect, idFilter: "CiCcid", validityChecker: ValidityHelper.AlwaysFlawless },
                { fieldName: "ClDesc", label: "Description *", className: "col-12", type: InputTypesEnum.TextBox, validityChecker: ValidityHelper.forRequiredTextField },
            ]
        },
    ]
}

export default EditClientLineWindowDescription;